/**
 * StageBadge - small acquisition-milestone chip: green when the stage is
 * reached, muted when not. Shared by admin acquisition funnel rows and the
 * admin owner detail header.
 */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import { useTheme } from '../context/ThemeContext';
import { fontWeight } from '../utils/theme';

interface StageBadgeProps {
  label: string;
  on: boolean;
}

export default function StageBadge({ label, on }: StageBadgeProps) {
  const { colors } = useTheme();
  return (
    <View style={[styles.badge, { backgroundColor: on ? '#05966915' : colors.background }]}>
      <Text style={[styles.badgeText, { color: on ? '#059669' : colors.textLight }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: { paddingHorizontal: 6, paddingVertical: 2, borderRadius: 8 },
  badgeText: { fontSize: 10, fontWeight: fontWeight.semibold },
});
